<div class="flex flex-col basis-full">
  <div class="flex flex-row display">
    <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
    <div class="flex flex-col items-center">
      <mat-icon svgIcon="info" class="w-48 h-48 amber_color"></mat-icon>
      <div class="fw-700 fs-24 failed-title mt-16 mb-16">{{title}}</div>
      <div class="flex justify-center">
        <span class="fw-500 fs-14 error-text">{{ ('ERROR_DIALOG.WARNING_REASON' | transloco) + ' (' + descriptionArray?.length + ') ' }}</span>
        <span (click)="viewClick()" class="ml-16 cursor-pointer underline" [ngClass]="{'mb-20': !viewMore}">{{defaultLinkTitle}}</span>
      </div>
      <div *ngIf="descriptionArray && viewMore" class="w-100-percent mb-4">
        <button class="flex justify-end h-30 error-copy-class pt-4 pr-16 pb-4 pl-16" [ngClass]="[copy ? 'copied': 'copy']" (click)="copyText(descriptionArray)">
          <span *ngIf="!copy" class="fs-16 fw-500 item flex items-center">
            <mat-icon class="h-18 w-18 mr-6" svgIcon="content_copy"></mat-icon>{{ 'ERROR_DIALOG.COPY' | transloco }}
          </span>
          <span *ngIf="copy" class="fs-16 fw-500 item flex items-center copied-text">
            <mat-icon class="h-18 w-18 mr-6" svgIcon="check"></mat-icon>{{ 'ERROR_DIALOG.COPIED' | transloco }}
          </span>
        </button>
      </div>
    
      <div *ngIf="descriptionArray && viewMore" class="overflow-class w-100-percent pr-16 pt-8 pl-16 ml-20" >
        <div *ngFor="let description of descriptionArray; let i = index; let last = last" class="mb-12 mt-12">
          <div>
            <span class="error-text">{{ ('ERROR_DIALOG.MESSAGE' | transloco) + ' ' }}</span><span class="value-text">{{description}}</span>
          </div>
          <mat-divider class="divider-color mt-12" *ngIf="!last"></mat-divider>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="descriptionArray" class="flex flex-row justify-center items-center mt-24 ml-auto">
    <button *ngIf="cancelButton" class="white mr-20 report-letter-spacing" type="button" (click)="matdialogRef.close()"> {{ 'ERROR_DIALOG.CANCEL' | transloco }} </button>
    <button class="error-report-bg-color accent report-letter-spacing mr-20" type="button" (click)="continue()"> {{ 'ERROR_DIALOG.UNDERSTAND_PROCEED' | transloco }} </button>
  </div>
</div>
